import MetaDataService from './service';

export * from './reqres';

export default MetaDataService;
